import Helmet from 'react-helmet'

const isNotEmpty = (string = '') => string.length > 0

const Meta = ({ title, htmlMetaTitle, htmlMetaDescription, htmlMetaKeywords }) => (
    <Helmet>
        {isNotEmpty(htmlMetaTitle) ? <title>{htmlMetaTitle}</title> : isNotEmpty(title) && <title>{title}</title>}

        {isNotEmpty(htmlMetaDescription) && <meta name="description" content={htmlMetaDescription} />}
        {isNotEmpty(htmlMetaKeywords) && <meta name="keywords" content={htmlMetaKeywords} />}
    </Helmet>
)

export default Meta
